import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export function useAddCandidateSkill() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, skill }) => {
      return axios.post(`/candidate/${candidate.uuid}/skill`, {
        ...skill,
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useRemoveCandidateSkill() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, skillId }) => {
      return axios.delete(`/candidate/${candidate.uuid}/skill`, {
        data: {
          skill_id: skillId,
        },
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}
